<!--
 * @Description: 引用字段
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="reference-field">
    <component :is="getComponent" :params="getFieldParams" :clickType="clickType" />
  </div>
</template>

<script setup>
import useEditFields from '@/hooks/edit-field';
// import useShowFields from "@/hooks/field-show";
const { getfieldCom } = useEditFields();
// const { getfieldShowCom } = useShowFields();
import { computed } from 'vue';
const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  },
  clickType: {
    type: Number,
    default: 0
  }
});

const getFieldParams = computed(() => props.params);
// 列表类型和详情类型的组件不同
const getComponent = computed(() => {
  return getfieldCom[getFieldParams.value.fieldType];
});
</script>
<style scoped lang="less">
@import './reference.less';
</style>
